import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";

const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

function FailedLoading(props) {
    const {classes} = props;
    return (
        <div>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item>
                    <Typography variant={"h6"}>Failed loading</Typography>
                    <div>
                        <Button variant={"contained"} onClick={props.retry}>Retry</Button>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}

FailedLoading.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FailedLoading);